import getSupplierFax1 from 'utils/print/getSupplierFax1';
import getSupplierFax2 from 'utils/print/getSupplierFax2';
import getSupplierFax3 from 'utils/print/getSupplierFax3';

const getSupplierFullFax = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const fax1 = getSupplierFax1(otherProps);
  const fax2 = getSupplierFax2(otherProps);
  const fax3 = getSupplierFax3(otherProps);
  if (fax1 && fax2 && fax3) {
    return `(${fax1}) ${fax2}-${fax3}`;
  }

  return null;
};

export default getSupplierFullFax;



// WEBPACK FOOTER //
// ./src/utils/print/getSupplierFullFax.js